import dynamic from 'next/dynamic';
import { ConfirmEventSummaryProps } from './ConfirmEventSummary.types';

export const ConfirmEventSummary = dynamic<{ model: ConfirmEventSummaryProps }>(() =>
  import('./ConfirmEventSummary').then(mod => mod.ConfirmEventSummary)
);
